import styled from 'styled-components';
import * as Avatar from '@radix-ui/react-avatar';
import sx from '../../sx.js';

const StyledAvatarRoot = styled(Avatar.Root).withConfig({
  displayName: "styles__StyledAvatarRoot",
  componentId: "sc-7lvyap-0"
})(["", ""], sx);
const StyledAvatarImage = styled(Avatar.Image).withConfig({
  displayName: "styles__StyledAvatarImage",
  componentId: "sc-7lvyap-1"
})(["width:100%;height:100%;object-fit:cover;border-radius:inherit;"]);

export { StyledAvatarImage, StyledAvatarRoot };
